import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
const vm = new Vue()
import appConfig from '@/common/appConfig'

Vue.use(VueRouter)

const routes = [{
    path: "/",
    redirect: "/HomePage"
  },
  {
    path: '/PlayerDetail',
    name: '播放-播放首页',
    component: () => import('../views/PlayerDetail.vue')
  },
  {
    path: '/Treaty',
    name: '协议页',
    component: () => import('../views/Treaty.vue')
  },
  {
    path: '/HomePage',
    name: '剧场-剧场首页',
    component: () => import('../views/HomePage.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  console.log('[beforeEach]-[to]', to)
  console.log('[beforeEach]-[from]', from)
  try {
    // if (!from.name) {
    //   REPORT_SDK.report({
    //     event_id: 'link_trigger',
    //     event_name: '链接触发'
    //   })
    // }
    if (!from.name && !to.query.code) {
      const appid = appConfig.currentApp.appid
      const params = vm.$utils.query(to.query)
      const url = appConfig.currentApp.webHost + to.path + params
      console.log('getCode', url, params,
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
          url
        )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      )
      window.top.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
          url
        )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      return
    }
    if (to.query.code) {
      const startInfo = vm.$utils.get(store.state.common, 'startInfo', {})
      console.log('[beforeEach]-用户登录', startInfo)
      if (to.query.code == vm.$utils.get(startInfo, 'query.code', null)) {
        console.log('[beforeEach]-store里存在相同code')
        store.commit('common/SET_REFERER', from.name ? from.name : '启动')
        store.commit('common/SET_CURRENTPAGE', to.name)
        next()
        return
      }
      try {
        await store.dispatch('user/initUserInfo', {
          code: to.query.code
        })
      } catch (err) {
        console.log(err)
      }
    }
    store.commit('common/SET_START_INFO', to)
    store.commit('common/SET_REFERER', from.name ? from.name : '启动')
    store.commit('common/SET_CURRENTPAGE', to.name)
    // store.commit('common/SET_REFERER', '启动')
    // store.commit('common/SET_CURRENTPAGE', '播放-播放首页')
    next()
  } catch (error) {
    console.log('router-error', error)
  }
})

export default router
